// Data
const data = {
	el: document.querySelector('.bg-glow_cursor'),
	glowX: 0,
	glowY: 0,
	mouseX: 0,
	mouseY: 0,
	ease: 0.11,
};

// Get cursor position
const getCursor = (e) => {
	data.el.classList.add('--active');
	data.mouseX = e.pageX;
	data.mouseY = e.pageY;
};
document.addEventListener('mousemove', getCursor);
document.addEventListener('wheel', getCursor);

// Set cursor position
const setCursor = () => {
	const distX = data.mouseX - data.glowX;
	const distY = data.mouseY - data.glowY;
	data.glowX = data.glowX + distX * data.ease;
	data.glowY = data.glowY + distY * data.ease;
	data.el.style.setProperty('--x', data.glowX + 'px');
	data.el.style.setProperty('--y', data.glowY + 'px');
	requestAnimationFrame(setCursor);
};
setCursor();

// Out of bounds
document.documentElement.addEventListener('mouseenter', () => {
	data.el.classList.add('--active');
});
document.documentElement.addEventListener('mouseleave', () => {
	data.el.classList.remove('--active');
});